import React from "react";
import * as PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import {withStyles} from '@material-ui/core/styles';
import PlantManagementUtility from "./PlantManagementUtility";
import Utility from "../../Utility";
import TextField from "@material-ui/core/TextField";

const styles = theme => ({
    dialogRoot: {
        textAlign: 'center'
    },
    tableTitle: {
        width: theme.spacing.unit,
        padding: theme.spacing.unit / 2,
    },
    tableHeader: {
        borderColor: 'white',
        borderStyle: 'solid',
        backgroundColor: 'skyblue',
        paddingTop: 0,
        paddingBottom: 0,
        textAlign: 'center',
        fontSize:'1rem',
    },
    tableValue: {
        paddingTop: 0,
        paddingBottom: 0,
        textAlign: 'center',
        fontSize:'1rem',
    },
    tableRow:{
        height:34,
    },
    remarksHeader: {
        border: theme.spacing.unit / 2,
        borderColor: 'white',
        borderStyle: 'solid',
        backgroundColor: 'skyblue',
        textAlign: 'center',
        height: 32
    },
    remarksValue: {
        paddingLeft: theme.spacing.unit / 2,
    },

    noteHeader:{
        border: theme.spacing.unit / 2,
        borderColor: 'white',
        borderStyle: 'solid',
        backgroundColor: 'skyblue',
        textAlign: 'center',
        height: 32
    },

    noteValue: {
        paddingLeft: theme.spacing.unit / 2,
    },

    noteButton: {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
    },

    saveButton:{
        backgroundColor:'#70ad47',
        "&:hover": {
            backgroundColor: '#4d8a32',
          },
    }
    
});

const CustomButton = (props) => {
    return (<Button onClick={props.onClick} variant="contained" color="primary" fullWidth>{props.label}</Button>)
};

const CustomButtonForNote = (props) => {
    return (<Button onClick={props.onClick} variant="contained" style={props.style} className={props.className}>{props.label}</Button>)
};

const CustomGridItem = (props) => {
    return (<Grid item xs={props.hasOwnProperty('xs') && props.xs} component={'div'} className={props.className}>{props.children}</Grid>)
};

class HeatExchangerInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenPutBackDialog: false,
            isOpenCarryOutDialog: false,
            action: false, 
            editedNote: "", 
            heatExchangerNote: this.props.heatExchanger.note 
        };

        this.carryOut = this.carryOut.bind(this);
        this.closeCarryOutDialog = this.closeCarryOutDialog.bind(this);
        this.closePutBackDialog = this.closePutBackDialog.bind(this);
        this.getRemarksText = this.getRemarksText.bind(this);
        this.onClickCarryOut = this.onClickCarryOut.bind(this);
        this.putBackFromLayout = this.putBackFromLayout.bind(this);
        this.releaseCarryOut = this.releaseCarryOut.bind(this);
    }

    carryOut() {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);

        // 搬出.
        newHeatExchanger.resultOfProcessIsCompleteCarryOut = PlantManagementUtility.PARAM_BOOL.TRUE; // 搬出(実績).
        newHeatExchanger.resultOfProcessCarryOutDatetime = Utility.getNowDatetimeString(); // 搬出(日時).

        this.props.onClickCarryOut(newHeatExchanger);

        this.closeCarryOutDialog();
    }

    closeCarryOutDialog() {
        this.setState({isOpenCarryOutDialog: false});
    }

    closePutBackDialog() {
        this.setState({isOpenPutBackDialog: false});
    }

    getRemarksText(heatExchanger) {
        let remarkStringArray = [];
        if (PlantManagementUtility.isParamTrue(heatExchanger.remarks1IronSulfide)) {
            remarkStringArray.push('硫化鉄');
        }
        if (PlantManagementUtility.isParamTrue(heatExchanger.remarks1OnePressure)) {
            remarkStringArray.push('一圧');
        }
        if (PlantManagementUtility.isParamTrue(heatExchanger.remarks1PureWaterDesignation)) {
            remarkStringArray.push('純水指定');
        }
        if (PlantManagementUtility.isParamTrue(heatExchanger.remarks1NeutralizationDesignation)) {
            remarkStringArray.push('中和指定');
        }
        if (PlantManagementUtility.isParamTrue(heatExchanger.remarks2Scrap)) {
            remarkStringArray.push('スクラップ');
        }
        if (PlantManagementUtility.isParamTrue(heatExchanger.remarks2Ritube)) {
            remarkStringArray.push('リチューブ');
        }
        return remarkStringArray.join('、');
    }

    //備考を編集
    handleEdit = () => {
        this.setState({ action: true, editedNote: this.state.heatExchangerNote });
    };

    //備考の修正内容を保存
    handleSave = () => {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        newHeatExchanger['note']= this.state.editedNote;
        newHeatExchanger.systemInfoUpdateDate = Utility.getNowDatetimeString(); 
        this.props.onChangeHeatExchanger(newHeatExchanger);
        //備考を表示する状態に戻す
        this.setState({ action: false , heatExchangerNote: newHeatExchanger.note  }); 
    };

    handleNoteChange = (e) => {
        this.setState({ editedNote: e.target.value });
    };

    onClickCarryOut() {
        if (PlantManagementUtility.isParamTrue(this.props.heatExchanger.resultOfProcessIsCompleteCarryOut)) {
            this.releaseCarryOut();
        } else {
            // 確認のダイアログを表示.
            this.setState({isOpenCarryOutDialog: true});
        }
    }

    putBackFromLayout() {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);

        // 熱交戻し.
        newHeatExchanger.sceneDetailNumber = ''; // 現場名(詳細)番号.
        newHeatExchanger.sceneDetailName = ''; // 現場名(詳細).
        newHeatExchanger.resultOfProcessIsCompleteCarryIn = PlantManagementUtility.PARAM_BOOL.FALSE; // 搬入(実績).
        newHeatExchanger.resultOfProcessCarryInDatetime = ''; // 搬入(日時).
        newHeatExchanger.systemInfoPositionX = ''; // 熱交配置(X座標).
        newHeatExchanger.systemInfoPositionY = ''; // 熱交配置(Y座標).
        newHeatExchanger.systemInfoRotation = '0'; // 熱交配置(角度). Androidアプリのソースコードにて角度のみ"0"を設定している.

        this.props.onClickPutBack(newHeatExchanger);

        this.closePutBackDialog();
    }

    releaseCarryOut() {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);

        // 搬出解除.
        newHeatExchanger.resultOfProcessIsCompleteCarryOut = PlantManagementUtility.PARAM_BOOL.FALSE; // 搬出(実績).
        newHeatExchanger.resultOfProcessCarryOutDatetime = ''; // 搬出(日時).

        this.props.onClickReleaseCarryOut(newHeatExchanger);
    }

    render() {
        const {classes, heatExchanger} = this.props;
        const apparatusMachineNumber = heatExchanger.instrumentApparatus + heatExchanger.instrumentMachineNumber;
        const { action } = this.state; // 状態を取得

        return (
            <Grid container component={'div'}>
                <CustomGridItem xs={6}>
                    <Table>
                        <TableBody>
                            <TableRow className={classes.tableRow}>
                                <td rowSpan={3} className={classes.tableTitle}>{'熱交情報'}</td>
                                <td className={classes.tableHeader}>{'装置機番'}</td>
                                <td className={classes.tableValue}>{apparatusMachineNumber}</td>
                                <td className={classes.tableHeader}>{'長さ'}</td>
                                <td className={classes.tableValue}>{heatExchanger.instrumentLength}</td>
                                <td className={classes.tableHeader}>{'重量'}</td>
                                <td className={classes.tableValue}>{heatExchanger.instrumentWeight}</td>
                            </TableRow>
                            <TableRow className={classes.tableRow}>
                                <td className={classes.tableHeader}>{'本数'}</td>
                                <td className={classes.tableValue}>{heatExchanger.instrumentNumberOfLines}</td>
                                <td className={classes.tableHeader}>{'内径'}</td>
                                <td className={classes.tableValue}>{heatExchanger.instrumentInnerDiameter}</td>
                                <td className={classes.tableHeader}>{'角度'}</td>
                                <td className={classes.tableValue}>{heatExchanger.systemInfoRotation}</td>
                            </TableRow>
                            <TableRow className={classes.tableRow}>
                                <td className={classes.tableHeader}>{'材質'}</td>
                                <td className={classes.tableValue}>{heatExchanger.instrumentMaterial}</td>
                                <td className={classes.tableHeader}>{'肉厚'}</td>
                                <td className={classes.tableValue}>{heatExchanger.instrumentThickness}</td>
                                <td className={classes.tableHeader}>{'型'}</td>
                                <td className={classes.tableValue}>{heatExchanger.instrumentType}</td>
                            </TableRow>
                        </TableBody>
                    </Table>
                </CustomGridItem>
                <CustomGridItem xs={6}>
                    <Grid container spacing={8} component={'div'}>
                        <CustomGridItem xs={4}>
                            <CustomButton
                                onClick={this.onClickCarryOut}
                                label={PlantManagementUtility.isParamTrue(heatExchanger.resultOfProcessIsCompleteCarryOut) ? '搬出解除' : '搬出'}/>
                        </CustomGridItem>
                        <CustomGridItem xs={4}>
                            <CustomButton
                                label={'熱交戻し'}
                                onClick={() => {
                                    this.setState({isOpenPutBackDialog: true})
                                }}
                            />
                        </CustomGridItem>
                        <CustomGridItem xs={4}>
                            <CustomButton onClick={this.props.onClickReturnLayout} label={'レイアウトへ'}/>
                        </CustomGridItem>
                        <CustomGridItem xs={4}>
                            <CustomGridItem xs={8} className={classes.remarksHeader}>{'特記事項'}</CustomGridItem>
                            <CustomGridItem  className={classes.remarksValue}>{this.getRemarksText(heatExchanger)}</CustomGridItem>
                        </CustomGridItem>
                        <CustomGridItem xs={8}>
                            <Grid container>
                                <CustomGridItem xs={4} className={classes.noteHeader}>{'備考'}</CustomGridItem>
                                <CustomGridItem xs={1} ></CustomGridItem>
                                <CustomGridItem xs={3} >
                                    <CustomGridItem >
                                        <CustomButtonForNote
                                            style={{color:"white", maxWidth: "100px", maxHeight: "30px", minWidth: "100px", minHeight: "30px"}}
                                            className={!action ? classes.noteButton : classes.saveButton}
                                            onClick={!action ? this.handleEdit : this.handleSave}
                                            label={!action ? "備考修正" : "保存"}/>
                                    </CustomGridItem>
                                </CustomGridItem>
                            </Grid>
                            <CustomGridItem className={classes.noteValue}>
                                {action ? (<TextField
                                    fullWidth
                                    value={this.state.editedNote}
                                    onChange={this.handleNoteChange}
                                    variant="outlined"
                                    InputProps={{
                                        style: {height: 30, marginTop:10,marginBottom:5},
                                    }}
                                />) 
                                    : (this.value = heatExchanger.note)
                                }
                            </CustomGridItem>
                        </CustomGridItem>
                    </Grid>
                </CustomGridItem>
                <Dialog open={this.state.isOpenCarryOutDialog} onClose={this.closeCarryOutDialog} className={classes.dialogRoot}>
                    <DialogTitle>搬出の確認</DialogTitle>
                    <DialogContent>
                        <DialogContentText>レイアウト画面から熱交を搬出します。<br/>よろしいですか？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.closeCarryOutDialog} color="secondary" variant="contained">いいえ</Button>
                        <Button fullWidth onClick={this.carryOut} color="primary" variant="contained">はい</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.isOpenPutBackDialog} onClose={this.closePutBackDialog} className={classes.dialogRoot}>
                    <DialogTitle>熱交戻しの確認</DialogTitle>
                    <DialogContent>
                        <DialogContentText>レイアウト画面に配置されている熱交を追加メニューに戻します。<br/>よろしいですか？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.closePutBackDialog} color="secondary" variant="contained">いいえ</Button>
                        <Button fullWidth onClick={this.putBackFromLayout} color="primary" variant="contained">はい</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        );
    }
}

HeatExchangerInfo.propTypes = {
    heatExchanger: PropTypes.object.isRequired,
    onClickCarryOut: PropTypes.func.isRequired,
    onClickPutBack: PropTypes.func.isRequired,
    onClickReturnLayout: PropTypes.func.isRequired,
    onClickReleaseCarryOut: PropTypes.func.isRequired,
    onChangeHeatExchanger:PropTypes.func.isRequired
};

export default withStyles(styles)(HeatExchangerInfo);
